import { createContext } from 'react'
import { AnchorScrollType } from './types'

type AnchorContextType = {
  type: AnchorScrollType
}

type AnchorContextProviderProps = {
  children: React.ReactNode
} & AnchorContextType

export const AnchorContext = createContext<AnchorContextType>({
  type: 'jump-js',
})

export const AnchorContextProvider = (props: AnchorContextProviderProps) => {
  const { children, type } = props
  return <AnchorContext.Provider value={{ type }}>{children}</AnchorContext.Provider>
}
